
import { useState } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import { AppRoutes } from './router';
import ContactModal from './components/feature/ContactModal';
import CookieBanner from './components/feature/CookieBanner';

function App() {
  const [contactOpen, setContactOpen] = useState(false);

  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <AppRoutes />
        <ContactModal isOpen={contactOpen} onClose={() => setContactOpen(false)} />
        <CookieBanner />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
